module.exports = __webpack_public_path__ + "static/thredup-resaleReport2020-42b42834f03ef2296d83a44f85a3e2b3.pdf";